import { createFileRoute } from '@tanstack/react-router';
import { BillingPage } from '@/features/billing/components/BillingPage';

export const Route = createFileRoute('/billing')({
  component: BillingPage,
});
